import { Dispatch } from 'redux';
import { notifyMe } from './service';
import { NotifyMeParams } from './types';
import { logger } from 'shared/logging';


export const sendNotifyMe = (params: NotifyMeParams) => (dispatch: Dispatch) => notifyMe(params)
  .then((response) => {
    dispatch({
      type: 'NOTIFY ME',
    });
    return response;
  })
  .catch((error) => {
    logger.error(error, 'Error in Notify me Action');
    return false;
  });
